/* eslint-disable no-param-reassign */

import { up, down } from 'slide-element';
import clickOutside from 'click-outside';
import announcer from './aria-announcer';

const openPanel = (btn, panel, label) => {
    document.querySelectorAll('.news-filters-group .filters[aria-expanded="true"]').forEach((openBtn) => {
        const expandedGroup = openBtn.closest('.news-filters-group');
        const expandedPanel = expandedGroup.querySelector('.filters-panel');
        up(expandedPanel);
        openBtn.setAttribute('aria-expanded', 'false');
        expandedPanel.setAttribute('aria-hidden', 'true');
    });

    down(panel);
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    announcer.announce(`Les filtres ${label} sont ouvert`);
};

const closePanel = (btn, panel, label) => {
    up(panel);
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    announcer.announce(`Les filtres ${label} sont fermés`);
};

document.querySelectorAll('.news-filters-group').forEach((group) => {
    const toggleBtn = group.querySelector('.filters');
    const panel = group.querySelector('.filters-panel');
    const label = toggleBtn?.querySelector('span.label')?.textContent || '';
    const countSpan = toggleBtn.querySelector('.filters-count');
    const checkboxes = panel.querySelectorAll('input[type="checkbox"]');
    const resetBtn = panel.querySelector('.btn-reset');

    if (toggleBtn && panel) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');

        toggleBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closePanel(toggleBtn, panel, label);
            } else {
                openPanel(toggleBtn, panel, label);
            }
        });

        const updateCount = () => {
            const selectedCount = [...checkboxes].filter((cb) => cb.checked).length;
            countSpan.innerHTML = selectedCount > 0 ? `(${selectedCount}) <span class="visuallyhidden">filtres sélectionnés</span>` : '';
        };

        checkboxes.forEach((cb) => {
            cb.addEventListener('change', updateCount);
        });

        updateCount();

        clickOutside(panel, () => {
            if (toggleBtn.getAttribute('aria-expanded') === 'true') {
                closePanel(toggleBtn, panel, label);
            }
        });

        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                checkboxes.forEach((cb) => { cb.checked = false; });
                updateCount();
            });
        }
    }
});
